import React from 'react';
import { Flex, P } from '@tpr/core';
import styles from './removedBox.module.scss';
var RemovedBox = function (_a) {
    var type = _a.type;
    return (React.createElement("div", { role: "alert", className: styles.confirmationBox },
        React.createElement(Flex, { cfg: {
                flex: '0 0 auto',
                alignItems: 'center',
                bg: 'neutral.5',
                justifyContent: 'center',
            } },
            React.createElement(P, { cfg: {
                    fontSize: 3,
                    color: 'white',
                    textAlign: 'center',
                    lineHeight: 3,
                    p: 10,
                }, className: styles.noMarginBottom },
                type,
                " removed successfully"))));
};
export default React.memo(RemovedBox);
//# sourceMappingURL=removedBox.js.map